<template>
    <div class="community-switcher" v-if="managed_communities.length > 1">
        Switch:
        <el-select
            @change="switchCommunity"
            class="ml-5"
            filterable
            placeholder="Switch Community..."
            v-model="selected_community"
        >
            <el-option
                :key="comm.id"
                :label="comm.name"
                :value="comm.id"
                v-for="comm in managed_communities"
            >
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selected_community: null,
            managed_communities: []
        };
    },
    created() {
        if (this.current_community) {
            this.getManagedCommunities();
            this.selected_community = this.current_community.id;
        }
    },
    computed: {
        current_community() {
            return this.$store.state.current_community;
        }
    },
    methods: {
        getManagedCommunities() {
            axios
                .get(`/web-api/community`, {
                    params: {
                        all: 1
                    }
                })
                .then((response) => {
                    this.managed_communities = response.data.data;
                });
        },
        switchCommunity(val) {
            let selected = _.find(this.managed_communities, { id: val });
            location.href =
                location.protocol +
                "//" +
                location.hostname.replace(
                    this.current_community.slug,
                    selected.slug
                ) +
                "/home";
        }
    }
};
</script>

<style scoped></style>
